import { TableName } from '../../constants/table';
import { getAllEntities, getByPartitionKey } from '../services/api-service';

import { useQuery } from '@tanstack/react-query';
import { ICommonCode } from '../../models/commonCode';

const commonCodeTableName = TableName.CommonCode;
const commonCodeMappingTableName = TableName.CommonCodeMapping;
const companyMasterTableName = TableName.CompanyMaster;

const getAllCommonCode = async (tenantId: string) => {
  const tenants = await getAllEntities(TableName.Tenant);
  const commonCodes = await getByPartitionKey(commonCodeTableName, tenantId);
  const commonCodeMappings = await getByPartitionKey(
    commonCodeMappingTableName,
    tenantId,
  );
  const companyMasters = await getByPartitionKey(
    companyMasterTableName,
    tenantId,
  );

  const mappingsByVendor = new Map<string, any[]>();
  commonCodeMappings.forEach((mapping: any) => {
    const vendorId = mapping.CommonCodeId;
    if (!mappingsByVendor.has(vendorId)) {
      mappingsByVendor.set(vendorId, []);
    }
    mappingsByVendor.get(vendorId)!.push(mapping);
  });

  const data: any[] = [];
  let index = 0;

  mappingsByVendor.forEach((mappings, vendorId) => {
    // Use the first mapping as the base
    const firstMapping = mappings[0];

    const tenantName = tenants.find(
      (e: { PartitionKey: string }) =>
        e.PartitionKey?.toLowerCase() ===
        firstMapping.PartitionKey.toLowerCase(),
    )?.RowKey;

    const matchingCommonCode = commonCodes.find(
      (e: { RowKey: string }) => e.RowKey === vendorId,
    );
    // Find the matching company using the CompanyId from the CommonCode
    const matchingCompany = companyMasters.find(
      (e: { RowKey: string }) => e.RowKey === matchingCommonCode?.CompanyId,
    );

    const result = {
      ...firstMapping,
      id: index++,
      tenantName,
      CommonCode: matchingCommonCode?.CommonCode,
      CommonCodeOCR:
        matchingCommonCode?.CommonCodeName || matchingCommonCode?.CommonCode, // Show only the original OCR from master table
      VendorGST: matchingCommonCode?.VendorGST,
      ChartOfAccount: matchingCommonCode?.ChartOfAccount,
      VoucherName: matchingCommonCode?.VoucherName,
      TDSThreshold: matchingCommonCode?.TDSThreshold,
      TDSResidualAmount: matchingCommonCode?.TDSResidualAmount,
      TDSRate: matchingCommonCode?.TDSRate,
      RowKey: vendorId,
      CompanyName: matchingCompany?.CompanyName,
      CommonCodeMappingRowKey: firstMapping.RowKey,
      VoucherSeries: matchingCommonCode?.VoucherSeries,
      SaleOrPurchaseType: matchingCommonCode?.SaleOrPurchaseType,
      MCName: matchingCommonCode?.MCName,
    };
    data.push(result);
  });

  return data as ICommonCode[];
};

export const useGetAllCommonCode = (tenantId: string) =>
  useQuery({
    queryKey: ['getAllCommonCode', tenantId],
    queryFn: async () => getAllCommonCode(tenantId),
  });
